import { useAppSelector } from 'src/redux/hooks';
import { GlobalState } from 'src/redux/store';

export const companySizeTurnoverSelector = (state: GlobalState) => state.companySizeTurnover;

export const companySizeTurnoverSelectorData = (state: GlobalState) =>
    companySizeTurnoverSelector(state).data;

export const useCompanySizeTurnover = () => useAppSelector(companySizeTurnoverSelectorData);
